import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
//添加登录信息到vuex 2024/05/06 BY lixiaolong
export default new Vuex.Store({
  state: {
    userInfo: {},
    favoriteList: [],
    xunjiaList: [],
    bijiaoList: [],
  },
  getters: {},
  mutations: {
    SET_MESSAGE(state, message) {
      state.userInfo = message;
    },
    SET_FAVORITELIST(state, message) {
      state.favoriteList = message;
    },
    SET_XUNJIALIST(state, message) {
      state.xunjiaList = message;
    },
    SET_BIJIAOLIST(state, message) {
      state.bijiaoList = message;
    },
  },
  actions: {
    setMessage({ commit }, message) {
      commit("SET_MESSAGE", message);
    },
    setFavoriteMessage({ commit }, message) {
      commit("SET_FAVORITELIST", message);
    },
    setxunjiaMessage({ commit }, message) {
      commit("SET_XUNJIALIST", message);
    },
    setbijiaoMessage({ commit }, message) {
      commit("SET_BIJIAOLIST", message);
    },
  },
  modules: {},
});
